(() => {
  const styleEnhancements = () => {
    if (document.getElementById('lcpp-conversion-enhancements')) return;
    const style = document.createElement('style');
    style.id = 'lcpp-conversion-enhancements';
    style.textContent = `
      .lcpp-product .lcpp-compatibility{margin-top:11px;padding:10px 12px;border:1px solid #dce7ef;border-radius:11px;background:#f8fbfd}.lcpp-product .lcpp-compatibility__label{display:flex;align-items:center;gap:6px;color:#496276;font-size:9px;font-weight:900;letter-spacing:.02em;text-transform:uppercase}.lcpp-product .lcpp-compatibility__label i{width:18px;height:18px;display:grid;place-items:center;border-radius:50%;background:#e8f7ef;color:#1d8a4d;font-style:normal;font-size:10px}.lcpp-product .lcpp-compatibility__values{margin-top:7px;display:flex;flex-wrap:wrap;gap:6px}.lcpp-product .lcpp-compatibility__values span{padding:6px 8px;border:1px solid #d9e5ed;border-radius:999px;background:#fff;color:#183b56;font-size:9.5px;font-weight:800}.lcpp-product .lcpp-specs{margin-top:13px}.lcpp-product .lcpp-specs__label{display:block;margin-bottom:7px;color:#60798b;font-size:9px;font-weight:900;letter-spacing:.03em;text-transform:uppercase}.lcpp-product .lcpp-specchips{display:flex;flex-wrap:wrap;gap:6px}.lcpp-product .lcpp-specchip{min-height:29px;padding:6px 9px;display:inline-flex;align-items:center;gap:5px;border:1px solid #dfe8ef;border-radius:8px;background:#f8fafc;color:#29475e;font-size:9.5px;line-height:1.2}.lcpp-product .lcpp-specchip b{color:#708494;font-size:8px;font-weight:850;text-transform:uppercase}.lcpp-product .lcpp-mobilebar__stock{margin-top:3px;display:flex;align-items:center;gap:5px;color:#247d48;font-size:8px;font-weight:850;line-height:1.1}.lcpp-product .lcpp-mobilebar__stock i{width:6px;height:6px;flex:0 0 6px;border-radius:50%;background:#3ebf70;box-shadow:0 0 0 3px rgba(62,191,112,.1)}.lcpp-product .lcpp-mobilebar__stock span{color:inherit;font-size:8px;font-weight:850;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.lcpp-product .lcpp-mobilebar__stock.is-out{color:#a45560}.lcpp-product .lcpp-mobilebar__stock.is-out i{background:#c96f7a;box-shadow:0 0 0 3px rgba(201,111,122,.1)}
      @media(max-width:599px){.lcpp-product .lcpp-compatibility{margin-top:9px;padding:9px 10px}.lcpp-product .lcpp-compatibility__values span{font-size:9px}.lcpp-product .lcpp-specs{margin-top:11px}.lcpp-product .lcpp-specchip{padding:6px 8px;font-size:9px}}
    `;
    document.head.appendChild(style);
  };

  let productJsonPromise;
  const getProductJson = () => {
    if (productJsonPromise) return productJsonPromise;
    const match = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!match) return Promise.resolve(null);
    const handle = decodeURIComponent(match[1]);
    productJsonPromise = fetch(`/products/${encodeURIComponent(handle)}.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then((response) => response.ok ? response.json() : null).catch(() => null);
    return productJsonPromise;
  };

  const structuredTags = (tags) => {
    const source = Array.isArray(tags)
      ? tags
      : (typeof tags === 'string' ? tags.split(',').map((tag) => tag.trim()) : []);

    return source.map((tag) => {
      if (typeof tag !== 'string' || !tag.startsWith('LCF__')) return null;
      const parts = tag.split('__');
      if (parts.length < 3) return null;
      return { key: parts[1], value: parts.slice(2).join('__').trim() };
    }).filter((item) => item && item.key && item.value);
  };

  const uniq = (items) => [...new Set(items.filter(Boolean))];

  const buildCompatibility = (values) => {
    if (!values.length) return null;
    const block = document.createElement('div');
    block.className = 'lcpp-compatibility';
    block.setAttribute('aria-label', 'Compatibiliteit');

    const label = document.createElement('div');
    label.className = 'lcpp-compatibility__label';
    const icon = document.createElement('i');
    icon.textContent = '✓';
    const text = document.createElement('span');
    text.textContent = 'Past op';
    label.append(icon, text);

    const pills = document.createElement('div');
    pills.className = 'lcpp-compatibility__values';
    values.forEach((value) => {
      const pill = document.createElement('span');
      pill.textContent = value;
      pills.appendChild(pill);
    });

    block.append(label, pills);
    return block;
  };

  const buildSpecs = (items) => {
    const order = ['Vermogen', 'Capaciteit', 'Aansluiting', 'Functie', 'Lengte', 'Type'];
    const labels = {
      Vermogen: 'Vermogen',
      Capaciteit: 'Capaciteit',
      Aansluiting: 'Poort',
      Functie: 'Functie',
      Lengte: 'Lengte',
      Type: 'Type'
    };

    const specs = [];
    order.forEach((key) => {
      uniq(items.filter((item) => item.key === key).map((item) => item.value)).forEach((value) => {
        if (specs.length < 8) specs.push({ key, value });
      });
    });

    if (!specs.length) return null;

    const block = document.createElement('div');
    block.className = 'lcpp-specs';
    block.setAttribute('aria-label', 'Belangrijkste specificaties');

    const title = document.createElement('span');
    title.className = 'lcpp-specs__label';
    title.textContent = 'Belangrijkste specificaties';

    const chips = document.createElement('div');
    chips.className = 'lcpp-specchips';
    specs.forEach((spec) => {
      const chip = document.createElement('span');
      chip.className = 'lcpp-specchip';
      const key = document.createElement('b');
      key.textContent = labels[spec.key] || spec.key;
      const value = document.createElement('span');
      value.textContent = spec.value;
      chip.append(key, value);
      chips.appendChild(chip);
    });

    block.append(title, chips);
    return block;
  };

  const enhanceProductFacts = async (root) => {
    if (root.dataset.lcppFactsReady === 'true') return;
    root.dataset.lcppFactsReady = 'true';

    const heading = root.querySelector('.lcpp-info h1');
    if (!heading) return;

    const productJson = await getProductJson();
    if (!productJson) return;

    const items = structuredTags(productJson.tags);
    if (!items.length) return;

    const compatValues = uniq(items.filter((item) => item.key === 'Compatibiliteit').map((item) => item.value));
    const compatibility = buildCompatibility(compatValues);
    if (compatibility) heading.insertAdjacentElement('afterend', compatibility);

    const specs = buildSpecs(items);
    if (specs) {
      const stock = root.querySelector('[data-lcpp-stock]');
      if (stock) stock.insertAdjacentElement('afterend', specs);
      else if (compatibility) compatibility.insertAdjacentElement('afterend', specs);
      else heading.insertAdjacentElement('afterend', specs);
    }
  };

  styleEnhancements();

  document.querySelectorAll('[data-lcpp-root]').forEach((root) => {
    enhanceProductFacts(root);

    const dataNode = root.querySelector('[data-lcpp-variants]');
    if (!dataNode) return;

    let labels = {};
    try { labels = JSON.parse(root.querySelector('[data-lcpp-labels]')?.textContent || '{}'); } catch (_) { labels = {}; }

    let variants = [];
    try { variants = JSON.parse(dataNode.textContent || '[]'); } catch (_) { return; }

    const select = root.querySelector('[data-lcpp-variant-select]');
    const price = root.querySelector('[data-lcpp-price]');
    const compare = root.querySelector('[data-lcpp-compare]');
    const stock = root.querySelector('[data-lcpp-stock]');
    const add = root.querySelector('[data-lcpp-add]');
    const addLabel = root.querySelector('[data-lcpp-add-label]');
    const sku = root.querySelector('[data-lcpp-sku]');
    const skuWrap = root.querySelector('[data-lcpp-sku-wrap]');
    const currency = root.dataset.currency || 'EUR';
    const locale = document.documentElement.lang || 'nl-NL';

    const money = (cents) => new Intl.NumberFormat(locale, { style: 'currency', currency }).format((Number(cents) || 0) / 100);

    const showMedia = (id) => {
      if (!id) return;
      root.querySelectorAll('[data-lcpp-media]').forEach((el) => { el.hidden = String(el.dataset.lcppMedia) !== String(id); });
      root.querySelectorAll('[data-lcpp-thumb]').forEach((el) => el.classList.toggle('is-active', String(el.dataset.lcppThumb) === String(id)));
    };

    root.querySelectorAll('[data-lcpp-thumb]').forEach((button) => {
      button.addEventListener('click', () => showMedia(button.dataset.lcppThumb));
    });

    const sync = () => {
      if (!select) return;
      const variant = variants.find((item) => String(item.id) === String(select.value));
      if (!variant) return;

      if (price) price.textContent = money(variant.price);
      if (compare) {
        const hasCompare = Number(variant.compare_at_price) > Number(variant.price);
        compare.hidden = !hasCompare;
        compare.textContent = hasCompare ? money(variant.compare_at_price) : '';
      }
      if (stock) {
        stock.classList.toggle('is-out', !variant.available);
        const label = stock.querySelector('span');
        if (label) label.textContent = variant.available ? (labels.stockAvailable || 'Op voorraad en bestelbaar') : (labels.stockSoldOut || 'Tijdelijk uitverkocht');
      }
      if (add) add.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? (labels.addAvailable || 'In winkelwagen') : (labels.addSoldOut || 'Uitverkocht');
      if (sku) sku.textContent = variant.sku || '';
      if (skuWrap) skuWrap.hidden = !variant.sku;
      if (variant.featured_media_id) showMedia(variant.featured_media_id);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };

    if (select) select.addEventListener('change', sync);
  });
})();
